import React, { useRef, useEffect, useState } from 'react'
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from 'swiper/react';
import AOS from 'aos';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import "swiper/css/pagination";

const SolutionCont =  ({ title, logoSrc, headImgSrc, date, tags, aboutItem, aboutImg, effectItem, caseItem = [] }) =>  {
    const swiperRef = useRef(null);
    const SwiperActive = caseItem.length > 3; // 슬라이드가 3개 초과일 때만 Swiper 활성화

    const handleNext = () => {
        swiperRef.current.swiper.slideNext();
    };

    const handlePrev = () => {
        swiperRef.current.swiper.slidePrev();
    };
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    // // AOS 초기화 및 리프레시
    useEffect(() => {
        AOS.init();
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    

    return (
        <div className="content sol-content">
            <div className="sol-head">
                <div className="container">
                    <div className="head-txt">
                        <div className="logo-area">
                            <img src={logoSrc} alt={title} />
                        </div>
                        <span className="title">{title}</span>
                        {/* <p className="txt">{description}</p> */}

                        <p>{date}</p>
                        <ul className="tag-group">
                            {tags.map((tag, index) => (
                                <li key={index} className="tag">{tag}</li>
                            ))}
                        </ul>
                    </div>
                    <div className="head-img">
                        <img src={headImgSrc} alt={title} />
                    </div>
                </div>
            </div>

            <div className="container">
                <div className="sol-about" data-aos="fade-up" data-aos-easing="ease-in-out" data-aos-delay="500">
                    <div className="tit-box">
                        <h3 className="title">제품 장점</h3>
                        <span className="txt">Product Advantages</span>
                    </div>

                    <div className="border-box">
                        <div className="top">
                            <ul className="about-group">
                                {aboutItem.map((item, index) => (
                                    <li key={index} className="item">{item}</li>
                                ))}
                            </ul>
                        </div>
                        <div className="about-cont">
                            <img src={aboutImg} alt={title} />
                        </div>

                    </div>
                </div>
            </div>

            <div className="sol-effect" data-aos="fade-up" data-aos-easing="ease-in-out" data-aos-delay="570">
                <div className="container">
                    <div className="tit-box">
                        <h3 className="title">도입 효과</h3>
                        <span className="txt">Introduction Effects</span>
                    </div>

                    <ul className="list-count">
                        {effectItem.map((item, index) => (
                            <li key={index} className="item">
                                <span className="number">{String(index + 1).padStart(2, "0")}</span> {/* 숫자 앞에 0을 채움 */}
                                <span className="info">{item}</span>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>

            {caseItem.length > 0 && (
                 <div className="container" data-aos="fade-up" data-aos-easing="ease-in-out" data-aos-delay="600">
                    <div className="sol-case">
                        <div className="tit-box">
                            <h3 className="title">도입 사례</h3>
                            <span className="txt">Introduction Case</span>
                        </div>
                        <div className="swiper-box">
                            {SwiperActive ? (
                                <Swiper
                                    ref={swiperRef}
                                    className="swiper-sol"
                                    modules={[Navigation, Pagination]}
                                    loop={true}
                                    // slidesPerView={3}  // 가운데 3개 슬라이드 표시
                                    slidesPerView={isMobile ? 1.5 : 3} // 모바일에서는 1.5개
                                    spaceBetween={20}  // 슬라이드 사이 간격
                                    slidesOffsetBefore = {20} // 슬라이드 시작 부분 여백
                                    slidesOffsetAfter = {30}
                                    loopAdditionalSlides = {1}
                                    navigation={
                                        !isMobile
                                            ? {
                                                  nextEl: ".swiper-button-next",
                                                  prevEl: ".swiper-button-prev",
                                              }
                                            : false
                                    }
                                    pagination={isMobile ? { el: ".swiper-pagination", clickable: true } : false}
                                >
                                    {caseItem.map((item, index) => (
                                        <SwiperSlide key={index}>
                                            <div className="card">
                                                <div className="project-img">
                                                    <img src={item.images} alt={item.name} />
                                                </div>
                                                <div className="project-txt">
                                                    <span className="name">{item.name}</span>
                                                    <p className="txt">{item.desc}</p>
                                                </div>
                                            </div>
                                        </SwiperSlide>
                                    ))}
                                    {isMobile && <div className="swiper-pagination"></div>}
                                </Swiper>
                            ):(
                                <div className="card-box">
                                    {caseItem.map((item, index) => (
                                        <div className="card" key={index}>
                                        <div className="project-img">
                                            <img src={item.images} alt={item.name} />
                                        </div>
                                        <div className="project-txt">
                                            <span className="name">{item.name}</span>
                                            <p className="txt">{item.desc}</p>
                                        </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                            {SwiperActive && (
                                <>
                                    <div className="swiper-button-prev" onClick={handlePrev}></div>
                                    <div className="swiper-button-next" onClick={handleNext}></div>
                                </>
                            )}
                            
                        </div>
                    </div>
                </div>
            )}

            <div className="btn-group">
                <Link to="/solutions/solution" className='btn main'>목록</Link>
            </div>      
        </div>
    );
};

export default SolutionCont;

